// test1874
(1874 && 0);
